<template>
  <div id="not-found">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex text-xs-center xs12>
          <h1 class="display-1">Oops!</h1>
        </v-flex>
        <v-flex text-xs-center xs12>
          <h3 class="headline">The page you're looking for is not here.</h3>
        </v-flex>
        <v-flex text-xs-center xs12>
          <router-link :to="{ name: 'home' }" class="body-1">Back to the home page</router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
